export default __webpack_public_path__ + "static/media/NoMorePlastics.4eada4f6.svg";